import type {
    AccountPetsErrorResponse,
    AccountPetsSuccessResponse,
    AccountPetsSuccessResponseCorrect,
    CreatePetBody,
    EditPetBody,
} from '@libs/common-next';
import type { PetsConfigAPI } from '@libs/common-types';
import { PetStatus } from '@libs/core';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

/** Profile / BFF pet status ids (see `PetStatus` in @libs/core) */
export type UpdatePetStatusBody = {
    petStatusId: PetStatus;
    removalReasonId?: number;
};

export async function addPet(body: Partial<CreatePetBody>) {
    const url = CWEA_ENDPOINTS.pets.addPet;
    return await cweaClient.post<AccountPetsErrorResponse | AccountPetsSuccessResponseCorrect, Partial<CreatePetBody>>(
        url,
        {
            body,
            additionalSuccessCodes: [409, 400],
        }
    );
}

export async function editPet(body: Partial<EditPetBody>, petId: string) {
    const url = CWEA_ENDPOINTS.pets.editPet(petId);
    return await cweaClient.put<AccountPetsErrorResponse | AccountPetsSuccessResponse, Partial<EditPetBody>>(url, {
        body,
        additionalSuccessCodes: [409],
    });
}

export async function getPets() {
    const url = CWEA_ENDPOINTS.pets.getPets;
    return await cweaClient.get<AccountPetsSuccessResponseCorrect[]>(url);
}

export async function removePet(petId: string) {
    const url = CWEA_ENDPOINTS.pets.removePet(petId);
    return await cweaClient.delete<AccountPetsErrorResponse>(url, {
        additionalSuccessCodes: [404, 400],
    });
}

export async function restorePet(petId: string, body: UpdatePetStatusBody) {
    const url = CWEA_ENDPOINTS.pets.updatePetStatus(petId);
    return await cweaClient.post<AccountPetsErrorResponse, UpdatePetStatusBody>(url, {
        body,
        additionalSuccessCodes: [400],
    });
}

export async function getPetsConfig() {
    const url = CWEA_ENDPOINTS.pets.getPetsConfig;
    return await cweaClient.get<PetsConfigAPI>(url, {
        additionalSuccessCodes: [400],
    });
}

export async function uploadPetPhoto(petId: string, formData: FormData) {
    const url = `${CWEA_ENDPOINTS.pets.uploadPetPhoto(petId)}`;
    return await cweaClient.post<unknown, FormData>(url, {
        body: formData,
        additionalSuccessCodes: [400, 413],
    });
}

export async function updatePetStatus(petId: string, body: UpdatePetStatusBody) {
    const url = `${CWEA_ENDPOINTS.pets.updatePetStatus(petId)}`;
    return await cweaClient.post<unknown, UpdatePetStatusBody>(url, {
        body,
    });
}
